import { PageType } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { SteamStudioIcons } from "scmp-app/components/posties/content-homepage/steam-studio/steam-studio-top-background/steam-studio-icons";
import { tracking } from "scmp-app/data";
import type { steamStudioQuery$key } from "scmp-app/queries/__generated__/steamStudioQuery.graphql";

import { SteamStudioDesktopIcons } from "./steam-studio-desktop-icons";
import {
  Container,
  ContentContainer,
  StyledContentItemPostiesPrimary,
  StyledHeadline,
} from "./styles";

type Props = {
  reference: steamStudioQuery$key;
};

export const SteamStudio: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const data = useFragment(
    graphql`
      fragment steamStudioQuery on Query {
        steamStudioSection: section(filter: { entityId: "515934" }) {
          ...headlineSection
        }
        steamStudioQueue: queue(filter: { entityId: "section_top_515934" }) {
          items(first: 1) {
            edges {
              node {
                ... on Article {
                  ...postiesPrimaryContentItemContent
                }
              }
            }
          }
        }
      }
    `,
    reference_,
  );

  const items = data?.steamStudioQueue?.items?.edges;

  const customQueryParameters = {
    module: tracking.module.SteamStudio,
    pgtype: tracking.pageType.Content,
  };

  return (
    <Container>
      <ContentContainer>
        <SteamStudioIcons />
        <StyledHeadline
          color="#FECC17"
          query={{
            pageType: PageType.PostiesSection,
            ...customQueryParameters,
          }}
          reference={data.steamStudioSection}
        />
        {items?.map((item, key) => (
          <StyledContentItemPostiesPrimary
            customQueryParameters={{
              pageType: PageType.PostiesArticle,
              ...customQueryParameters,
            }}
            key={key}
            reference={item.node}
          />
        ))}
      </ContentContainer>
      <SteamStudioDesktopIcons />
    </Container>
  );
};

SteamStudio.displayName = "SteamStudio";
